import React from "react";
import videojs from "@mux/videojs-kit";
import "@mux/videojs-kit/dist/index.css";

export const VideoJS = ({ playbackID, onReady, title = "Video Player" }) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);

  // Initialize player only once
  React.useEffect(() => {
    if (!playerRef.current && videoRef.current) {
      const player = videojs(videoRef.current, {
        controls: true,
        responsive: true,
        fluid: true,
        playbackRates: [0.5, 1, 1.5, 2],
        plugins: {
          // NOTE: no `httpSourceSelector` here — that plugin isn't a
          // dependency/registered, and requesting it makes video.js throw
          // `plugin "httpSourceSelector" does not exist` on init, which
          // crashed the whole Quick Tap edit page (every saved QT has a
          // Mux playback id, so the player always mounted). Mux's own
          // plugin handles HLS rendition switching.
          mux: {
            debug: false,
          }
        },
        timelineHoverPreviews: false,
        controlBar: {
          children: [
            'playToggle',
            'volumePanel',
            'progressControl',
            'currentTimeDisplay',
            'timeDivider',
            'durationDisplay',
            'playbackRateMenuButton',
            'fullscreenToggle'
          ]
        }
      });

      playerRef.current = player;
      onReady && onReady(player);

      // Error handling
      player.on('error', (error) => {
        console.error('Video.js error:', error);
      });
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [onReady]);

  // Update source when playbackID changes
  React.useEffect(() => {
    if (playerRef.current) {
      if (playbackID?.length > 0) {
        playerRef.current.src({
          type: "video/mux",
          src: playbackID,
        });
      } else {
        // Clear the source if playbackID is empty
        playerRef.current.src([]);
      }
    }
  }, [playbackID]);

  return (
    <div className="video-container" style={{
      width: '100%',
      maxWidth: '800px',
      margin: '0 auto',
      backgroundColor: '#000',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    }}>
      <video
        ref={videoRef}
        className="video-js vjs-16-9 vjs-big-play-centered"
        controls
        preload="auto"
        width="100%"
        height="auto"
        style={{ aspectRatio: '16/9' }}
      />
    </div>
  );
};

export default VideoJS;
